import { render, staticRenderFns } from "./FollowingLifeskillsPanel.vue?vue&type=template&id=4211afca&scoped=true&"
import script from "./FollowingLifeskillsPanel.vue?vue&type=script&lang=js&"
export * from "./FollowingLifeskillsPanel.vue?vue&type=script&lang=js&"
import style0 from "./FollowingLifeskillsPanel.vue?vue&type=style&index=0&id=4211afca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4211afca",
  null
  
)

/* custom blocks */
import block0 from "./FollowingLifeskillsPanel.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports